import React from "react";
import ReactECharts from "echarts-for-react";
import UnitConverterWeight from "../../utils/UnitConverter";

function HighchartPie(props, translate) {
  // Convert the data format from Highcharts to ECharts format
  const seriesData = props.map(item => ({
    name: item.name,
    value: item.y,
    itemStyle: item.color ? { color: item.color } : undefined
  }));

  const options = {
    tooltip: {
      trigger: 'item',
      formatter: function(params) {
        // Find the original data item to get the 'quan' property
        const originalItem = props.find(item => item.name === params.name);
        return `${params.name}: ${originalItem ? originalItem.quan : params.value}`;
      }
    },
    legend: {
      orient: 'vertical',
      right: 10,
      top: 'middle',
      type: 'scroll',
      textStyle: {
        fontSize: 12
      }
    },
    series: [
      {
        name: translate("stats"),
        type: 'pie',
        radius: '70%',
        center: ['40%', '50%'],
        data: seriesData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        label: {
          show: false
        },
        labelLine: {
          show: false
        }
      }
    ]
  };

  return <ReactECharts option={options} style={{ height: '180px', width: '100%' }} />
}
export default HighchartPie;
